module.exports = __webpack_public_path__ + "img/mouse_right_button.671c6236.svg";